/* Tool-intro mini lesson scripts.
   12 builders, ~2-3 minutes each, ~15 kinetic cards per lesson.
   Voice: Mike — plain English, no preaching, direct.
   Add tool-specific video URLs as Mike records them (currently using sample). */

const VIDEO_DEFAULT =
  "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/8989hdbk_MB%20Sample%202%20%282%29.mp4";

export const TOOL_INTROS = [
  {
    slug: "funnel-builder",
    n: 1,
    name: "Funnel Builder",
    tagline: "Build high-converting sales funnels.",
    color: "#1E64C4",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "FUNNEL BUILDER",                         kind: "title",   subtitle: "Mini Lesson #1 of 12" },
      { time: 7,   text: "What is a funnel?",                       kind: "tagline" },
      { time: 14,  text: "A path. Click. Page. Sale.",              kind: "tagline" },
      { time: 22,  text: "Opt-in → Thank You → Upsell → Checkout",  kind: "tagline" },
      { time: 32,  text: "Built-in templates.",                     kind: "tagline" },
      { time: 39,  text: "Books. Supplements. Services. Giveaways.", kind: "tagline" },
      { time: 49,  text: "$97 a month somewhere else.",             kind: "stat" },
      { time: 58,  text: "Included here.",                          kind: "tagline" },
      { time: 67,  text: "Every step connected.",                   kind: "tagline" },
      { time: 75,  text: "Emails follow the visitor.",              kind: "tagline" },
      { time: 84,  text: "Clicks follow the visitor.",              kind: "tagline" },
      { time: 93,  text: "Sales follow the visitor.",               kind: "tagline" },
      { time: 104, text: "Build it once.",                          kind: "tagline" },
      { time: 112, text: "Sell forever.",                           kind: "tagline" },
      { time: 121, text: "50/50 commission.",                       kind: "stat",    subtitle: "On every sale a visitor makes through your funnel." },
      { time: 134, text: "If you can post on Facebook,",            kind: "quote" },
      { time: 142, text: "you can run a funnel.",                   kind: "quote" },
      { time: 152, text: "Open Funnel Builder.",                    kind: "title",   subtitle: "My Office → Funnel Builder" },
      { time: 165, text: "Let's build.",                            kind: "tagline" },
    ],
  },
  {
    slug: "course-builder",
    n: 2,
    name: "Course Builder",
    tagline: "Create and sell online courses.",
    color: "#F39A1F",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "COURSE BUILDER",                          kind: "title",   subtitle: "Mini Lesson #2 of 12" },
      { time: 7,   text: "You know something.",                     kind: "tagline" },
      { time: 14,  text: "Someone wants to learn it.",              kind: "tagline" },
      { time: 22,  text: "Turn it into a course.",                  kind: "tagline" },
      { time: 31,  text: "Upload videos.",                          kind: "tagline" },
      { time: 38,  text: "Upload PDFs.",                            kind: "tagline" },
      { time: 45,  text: "Upload audio.",                           kind: "tagline" },
      { time: 53,  text: "Set a price.",                            kind: "tagline" },
      { time: 61,  text: "Done.",                                   kind: "stat" },
      { time: 69,  text: "Checkout: handled.",                      kind: "tagline" },
      { time: 77,  text: "Delivery: automatic.",                    kind: "tagline" },
      { time: 86,  text: "Students log in. Watch. Pay.",            kind: "tagline" },
      { time: 96,  text: "You get paid the same day.",              kind: "tagline" },
      { time: 106, text: "No Teachable. No Kajabi.",                kind: "tagline" },
      { time: 116, text: "No $99 a month somewhere else.",          kind: "stat" },
      { time: 127, text: "Build the course once.",                  kind: "tagline" },
      { time: 135, text: "Sell it a thousand times.",               kind: "tagline" },
      { time: 145, text: "50/50 commission for affiliates too.",    kind: "stat" },
      { time: 158, text: "Open Course Builder.",                    kind: "title",   subtitle: "My Office → Course Builder" },
      { time: 170, text: "Start teaching.",                         kind: "tagline" },
    ],
  },
  {
    slug: "email-builder",
    n: 3,
    name: "Email Builder",
    tagline: "Send emails and grow your list.",
    color: "#C9202E",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "EMAIL BUILDER",                           kind: "title",   subtitle: "Mini Lesson #3 of 12" },
      { time: 7,   text: "Your list is your lifeline.",             kind: "quote" },
      { time: 15,  text: "Send broadcasts.",                        kind: "tagline" },
      { time: 23,  text: "Right from My Office.",                   kind: "tagline" },
      { time: 31,  text: "Pick a template.",                        kind: "tagline" },
      { time: 39,  text: "Drop in a photo.",                        kind: "tagline" },
      { time: 47,  text: "Write a headline.",                       kind: "tagline" },
      { time: 55,  text: "Hit send.",                               kind: "tagline" },
      { time: 63,  text: "Open rates tracked.",                     kind: "tagline" },
      { time: 71,  text: "Click rates tracked.",                    kind: "tagline" },
      { time: 79,  text: "You know what works.",                    kind: "tagline" },
      { time: 89,  text: "$30 to $70 a month somewhere else.",      kind: "stat" },
      { time: 100, text: "Included here.",                          kind: "tagline" },
      { time: 110, text: "Talk to your people.",                    kind: "tagline" },
      { time: 120, text: "Often.",                                  kind: "stat" },
      { time: 130, text: "Without paying extra.",                   kind: "tagline" },
      { time: 142, text: "Open Email Builder.",                     kind: "title",   subtitle: "My Office → Email Builder" },
      { time: 156, text: "Write your first one.",                   kind: "tagline" },
    ],
  },
  {
    slug: "market-builder",
    n: 4,
    name: "Market Builder",
    tagline: "Open your own market — sell products and services online.",
    color: "#2E9F3A",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "MARKET BUILDER",                          kind: "title",   subtitle: "Mini Lesson #4 of 12" },
      { time: 8,   text: "Your own digital market.",                kind: "tagline" },
      { time: 16,  text: "faitharama.com/store/your-name",          kind: "tagline" },
      { time: 26,  text: "Books. Courses. Coaching. PDFs.",         kind: "tagline" },
      { time: 36,  text: "Supplements. Merch. Anything.",           kind: "tagline" },
      { time: 46,  text: "Checkout — handled.",                     kind: "tagline" },
      { time: 54,  text: "Receipts — handled.",                     kind: "tagline" },
      { time: 62,  text: "Delivery emails — handled.",              kind: "tagline" },
      { time: 71,  text: "No Shopify fee.",                         kind: "stat" },
      { time: 80,  text: "No PayPal headaches.",                    kind: "tagline" },
      { time: 88,  text: "No tech tickets at midnight.",            kind: "tagline" },
      { time: 98,  text: "One link.",                               kind: "tagline" },
      { time: 105, text: "One market.",                             kind: "tagline" },
      { time: 113, text: "Yours.",                                  kind: "stat" },
      { time: 123, text: "Start with one product.",                 kind: "tagline" },
      { time: 132, text: "Add more when you're ready.",             kind: "tagline" },
      { time: 142, text: "Open Market Builder.",                    kind: "title",   subtitle: "My Office → My Market" },
      { time: 156, text: "Open your doors.",                        kind: "tagline" },
    ],
  },
  {
    slug: "ai-writer",
    n: 5,
    name: "AI Writer",
    tagline: "Write content in seconds.",
    color: "#1E64C4",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "AI WRITER",                               kind: "title",   subtitle: "Mini Lesson #5 of 12" },
      { time: 7,   text: "Powered by Claude.",                      kind: "stat" },
      { time: 15,  text: "The cleanest AI on the market.",          kind: "tagline" },
      { time: 24,  text: "Tell it what you need.",                  kind: "tagline" },
      { time: 32,  text: "Sales email.",                            kind: "tagline" },
      { time: 40,  text: "Facebook post.",                          kind: "tagline" },
      { time: 48,  text: "Devotional.",                             kind: "tagline" },
      { time: 56,  text: "Book chapter.",                           kind: "tagline" },
      { time: 64,  text: "30 seconds.",                             kind: "stat" },
      { time: 72,  text: "First draft on your screen.",             kind: "tagline" },
      { time: 81,  text: "In your voice.",                          kind: "tagline" },
      { time: 90,  text: "Sample prompts built in.",                kind: "tagline" },
      { time: 99,  text: "Never stare at a blank page.",            kind: "quote" },
      { time: 110, text: "Edit it.",                                kind: "tagline" },
      { time: 117, text: "Rewrite it.",                             kind: "tagline" },
      { time: 124, text: "Hit save.",                               kind: "tagline" },
      { time: 132, text: "Publish.",                                kind: "stat" },
      { time: 142, text: "Daily content. No burnout.",              kind: "tagline" },
      { time: 154, text: "Open AI Writer.",                         kind: "title",   subtitle: "My Office → AI Writer" },
      { time: 166, text: "Start writing.",                          kind: "tagline" },
    ],
  },
  {
    slug: "ask-mike",
    n: 6,
    name: "Ask Mike",
    tagline: "Get answers and mentorship 24/7.",
    color: "#7B3FA3",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "ASK MIKE",                                kind: "title",   subtitle: "Mini Lesson #6 of 12" },
      { time: 7,   text: "A 24/7 mentor.",                          kind: "tagline" },
      { time: 14,  text: "In your pocket.",                         kind: "tagline" },
      { time: 22,  text: "Ask anything.",                           kind: "tagline" },
      { time: 30,  text: "How do I write a headline?",              kind: "quote" },
      { time: 39,  text: "What should I post today?",               kind: "quote" },
      { time: 48,  text: "How do I follow up with a lead?",         kind: "quote" },
      { time: 58,  text: "Plain English answers.",                  kind: "tagline" },
      { time: 67,  text: "Common-man voice.",                       kind: "tagline" },
      { time: 76,  text: "Trained on Faitharama.",                  kind: "tagline" },
      { time: 84,  text: "Trained on the playbooks.",               kind: "tagline" },
      { time: 92,  text: "Stuck at midnight?",                      kind: "tagline" },
      { time: 100, text: "Need a kind word?",                       kind: "tagline" },
      { time: 109, text: "Ask Mike answers.",                       kind: "stat" },
      { time: 119, text: "No appointment.",                         kind: "tagline" },
      { time: 127, text: "No waiting.",                             kind: "tagline" },
      { time: 135, text: "No invoice.",                             kind: "tagline" },
      { time: 145, text: "The patient mentor",                      kind: "quote" },
      { time: 153, text: "you couldn't afford to hire.",            kind: "quote" },
      { time: 163, text: "Open Ask Mike.",                          kind: "title",   subtitle: "My Office → Ask Mike" },
    ],
  },
  {
    slug: "mirror-site-builder",
    n: 7,
    name: "Mirror Site Builder",
    tagline: "Build your landing pages fast.",
    color: "#2E9F3A",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "MIRROR SITE BUILDER",                     kind: "title",   subtitle: "Mini Lesson #7 of 12" },
      { time: 8,   text: "Your own landing page.",                  kind: "tagline" },
      { time: 16,  text: "Drag and drop.",                          kind: "tagline" },
      { time: 24,  text: "Pick a template.",                        kind: "tagline" },
      { time: 32,  text: "Drop in your photo.",                     kind: "tagline" },
      { time: 40,  text: "Write three lines.",                      kind: "tagline" },
      { time: 48,  text: "Hit save.",                               kind: "tagline" },
      { time: 56,  text: "Live in 60 seconds.",                     kind: "stat" },
      { time: 66,  text: "Your URL:",                               kind: "tagline" },
      { time: 73,  text: "faitharama.com/u/your-name",              kind: "tagline" },
      { time: 84,  text: "Share it on Facebook.",                   kind: "tagline" },
      { time: 92,  text: "Share it in texts.",                      kind: "tagline" },
      { time: 100, text: "Print it on a business card.",            kind: "tagline" },
      { time: 110, text: "Collects emails automatically.",          kind: "tagline" },
      { time: 120, text: "Builds your list while you sleep.",       kind: "quote" },
      { time: 132, text: "No domain to buy.",                       kind: "tagline" },
      { time: 140, text: "No code to learn.",                       kind: "tagline" },
      { time: 148, text: "No designer to hire.",                    kind: "tagline" },
      { time: 158, text: "Open Mirror Site.",                       kind: "title",   subtitle: "My Office → Mirror Site" },
    ],
  },
  {
    slug: "book-cover-designer",
    n: 8,
    name: "Book Cover Designer",
    tagline: "Design professional book covers.",
    color: "#F39A1F",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "BOOK COVER DESIGNER",                     kind: "title",   subtitle: "Mini Lesson #8 of 12" },
      { time: 8,   text: "Got a book in you?",                      kind: "quote" },
      { time: 16,  text: "Type the title.",                         kind: "tagline" },
      { time: 23,  text: "Pick a style.",                           kind: "tagline" },
      { time: 30,  text: "60 seconds.",                             kind: "stat" },
      { time: 38,  text: "Five professional covers.",               kind: "tagline" },
      { time: 47,  text: "Print-ready.",                            kind: "tagline" },
      { time: 54,  text: "Social-ready.",                           kind: "tagline" },
      { time: 61,  text: "Ad-ready.",                               kind: "tagline" },
      { time: 70,  text: "Pair with the AI Writer.",                kind: "tagline" },
      { time: 79,  text: "Publish-ready book in days.",             kind: "stat" },
      { time: 89,  text: "Not years.",                              kind: "tagline" },
      { time: 97,  text: "Don't love it?",                          kind: "tagline" },
      { time: 105, text: "Order a custom cover.",                   kind: "tagline" },
      { time: 113, text: "$25. Three free revisions.",              kind: "stat" },
      { time: 124, text: "Still cheaper than the competition.",     kind: "tagline" },
      { time: 134, text: "Stop dreaming about the book.",           kind: "quote" },
      { time: 144, text: "Make the cover today.",                   kind: "quote" },
      { time: 156, text: "Open Book Cover Designer.",               kind: "title",   subtitle: "My Office → Book Cover" },
    ],
  },
  {
    slug: "community-builder",
    n: 9,
    name: "Community Builder",
    tagline: "Build and engage your community.",
    color: "#2E9F3A",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "COMMUNITY BUILDER",                       kind: "title",   subtitle: "Mini Lesson #9 of 12" },
      { time: 8,   text: "A private community.",                    kind: "tagline" },
      { time: 16,  text: "For your audience.",                      kind: "tagline" },
      { time: 24,  text: "Members log in.",                         kind: "tagline" },
      { time: 32,  text: "Share. Encourage. Grow.",                 kind: "tagline" },
      { time: 41,  text: "Forums.",                                 kind: "tagline" },
      { time: 48,  text: "Comments.",                               kind: "tagline" },
      { time: 55,  text: "Group chat.",                             kind: "tagline" },
      { time: 63,  text: "No Facebook algorithm.",                  kind: "stat" },
      { time: 73,  text: "Hiding your posts.",                      kind: "tagline" },
      { time: 82,  text: "An audience YOU own.",                    kind: "stat" },
      { time: 92,  text: "Not one a platform can shut off.",        kind: "tagline" },
      { time: 103, text: "Real conversations.",                     kind: "tagline" },
      { time: 111, text: "Real relationships.",                     kind: "tagline" },
      { time: 119, text: "Real customers.",                         kind: "stat" },
      { time: 130, text: "Built where YOU control the rules.",      kind: "quote" },
      { time: 142, text: "Open Community Builder.",                 kind: "title",   subtitle: "My Office → Community" },
      { time: 156, text: "Open the doors.",                         kind: "tagline" },
    ],
  },
  {
    slug: "appointment-booking",
    n: 10,
    name: "Appointment Booking",
    tagline: "Book appointments automatically.",
    color: "#1E64C4",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "APPOINTMENT BOOKING",                     kind: "title",   subtitle: "Mini Lesson #10 of 12" },
      { time: 8,   text: "Set your hours.",                         kind: "tagline" },
      { time: 16,  text: "Share your link.",                        kind: "tagline" },
      { time: 24,  text: "Visitors book themselves.",               kind: "tagline" },
      { time: 33,  text: "Right on your calendar.",                 kind: "tagline" },
      { time: 42,  text: "Confirmation email — sent.",              kind: "tagline" },
      { time: 51,  text: "24-hour reminder — sent.",                kind: "tagline" },
      { time: 60,  text: "Nobody no-shows.",                        kind: "stat" },
      { time: 70,  text: "Your booking page:",                      kind: "tagline" },
      { time: 78,  text: "faitharama.com/m/your-name/book",         kind: "tagline" },
      { time: 89,  text: "No Calendly fee.",                        kind: "stat" },
      { time: 99,  text: "No double bookings.",                     kind: "tagline" },
      { time: 107, text: "No back-and-forth emails.",               kind: "tagline" },
      { time: 117, text: "For coaches.",                            kind: "tagline" },
      { time: 124, text: "For pastors.",                            kind: "tagline" },
      { time: 131, text: "For anybody who sells time.",             kind: "tagline" },
      { time: 142, text: "Turn traffic into paid time.",            kind: "quote" },
      { time: 155, text: "Open Appointments.",                      kind: "title",   subtitle: "My Office → Appointments" },
    ],
  },
  {
    slug: "automation-builder",
    n: 11,
    name: "Automation Builder",
    tagline: "Automate your marketing.",
    color: "#7B3FA3",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "AUTOMATION BUILDER",                      kind: "title",   subtitle: "Mini Lesson #11 of 12" },
      { time: 8,   text: "Set it once.",                            kind: "tagline" },
      { time: 15,  text: "It runs forever.",                        kind: "tagline" },
      { time: 24,  text: "Welcome email sequence.",                 kind: "tagline" },
      { time: 33,  text: "Abandoned cart reminder.",                kind: "tagline" },
      { time: 43,  text: "7-day onboarding drip.",                  kind: "tagline" },
      { time: 53,  text: "Birthday messages.",                      kind: "tagline" },
      { time: 62,  text: "Faitharama runs it 24/7.",                kind: "stat" },
      { time: 73,  text: "You don't touch it.",                     kind: "tagline" },
      { time: 82,  text: "Build the offer once.",                   kind: "tagline" },
      { time: 91,  text: "Sell it forever.",                        kind: "tagline" },
      { time: 100, text: "Income while you sleep.",                 kind: "quote" },
      { time: 111, text: "Income while you're with family.",        kind: "quote" },
      { time: 122, text: "Income while you're fishing.",            kind: "quote" },
      { time: 133, text: "The promise everyone makes.",             kind: "tagline" },
      { time: 142, text: "Built into Faitharama.",                  kind: "stat" },
      { time: 154, text: "Open Automation Builder.",                kind: "title",   subtitle: "My Office → Automation" },
      { time: 168, text: "Stop trading hours for dollars.",         kind: "tagline" },
    ],
  },
  {
    slug: "membership-builder",
    n: 12,
    name: "Membership Builder",
    tagline: "Create membership sites.",
    color: "#D4A017",
    duration: 180,
    video: VIDEO_DEFAULT,
    cards: [
      { time: 0,   text: "MEMBERSHIP BUILDER",                      kind: "title",   subtitle: "Mini Lesson #12 of 12" },
      { time: 8,   text: "Charge monthly.",                         kind: "tagline" },
      { time: 15,  text: "Or yearly.",                              kind: "tagline" },
      { time: 22,  text: "For access to your courses.",             kind: "tagline" },
      { time: 31,  text: "For access to your community.",           kind: "tagline" },
      { time: 40,  text: "For access to your library.",             kind: "tagline" },
      { time: 49,  text: "Stripe handles rebilling.",               kind: "tagline" },
      { time: 58,  text: "Faitharama handles login.",               kind: "tagline" },
      { time: 67,  text: "You build the offer.",                    kind: "tagline" },
      { time: 75,  text: "Once.",                                   kind: "stat" },
      { time: 84,  text: "Recurring income.",                       kind: "stat" },
      { time: 94,  text: "Every month.",                            kind: "tagline" },
      { time: 102, text: "Without doing the work twice.",           kind: "tagline" },
      { time: 113, text: "100 members at $10 = $1,000/month.",      kind: "stat" },
      { time: 125, text: "100 members at $49 = $2,900/month.",      kind: "stat" },
      { time: 138, text: "Simple math.",                            kind: "quote" },
      { time: 146, text: "Hard work — once.",                       kind: "quote" },
      { time: 156, text: "Open Membership Builder.",                kind: "title",   subtitle: "My Office → Membership" },
      { time: 170, text: "Build your tribe.",                       kind: "tagline" },
    ],
  },
];

export const TOOL_INTROS_BY_SLUG = Object.fromEntries(TOOL_INTROS.map((t) => [t.slug, t]));
